import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { I18nModule } from '@spartacus/core'
import { CardModule, SpinnerModule } from '@spartacus/storefront'
import { AddressFormModule } from "@spartacus/user/profile/components"
import { CustomParagraphModule } from '../../checkout/custom-shipping-address/custom-paragraph/custom-paragraph.module'
import { MaterialModule } from '../material.module'
import { CardComponent } from './card.component'

@NgModule({
  declarations: [CardComponent],
  imports: [
    CommonModule,
    RouterModule,
    AddressFormModule,
    CardModule,
    SpinnerModule,
    I18nModule,
    MaterialModule,
    CustomParagraphModule
  ],
  providers: [],
  exports: [CardComponent]
})
export class CustomCardModule { }
